/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ErrorOutput,
  LinkPreviewAcceptedOutput,
  LinkPreviewInput,
  LinkPreviewResult,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create link preview
 */
export const createLinkPreview = (
    linkPreviewInput?: MaybeRefOrGetter<LinkPreviewInput>,
 signal?: AbortSignal
) => {
      linkPreviewInput = toValue(linkPreviewInput);

      return axiosClient<LinkPreviewResult | LinkPreviewAcceptedOutput>(
      {url: `/link_preview/previews`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: linkPreviewInput, signal
    },
      );
    }




export const getCreateLinkPreviewMutationKey = () => ['createLinkPreview'] as const;

export const getCreateLinkPreviewMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ErrorOutput>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLinkPreview>>, TError,CreateLinkPreviewMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createLinkPreview>>, TError,CreateLinkPreviewMutationVariables, TContext> => {

const mutationKey = getCreateLinkPreviewMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLinkPreview>>, CreateLinkPreviewMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createLinkPreview(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLinkPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof createLinkPreview>>>
    export type CreateLinkPreviewMutationBody = LinkPreviewInput | undefined
    export type CreateLinkPreviewMutationError = ErrorType<SchemaValidationErrorResponse | void | ErrorOutput>
    export type CreateLinkPreviewMutationVariables = {data?: LinkPreviewInput}

    /**
 * @summary Create link preview
 */
export const useCreateLinkPreview = <TError = ErrorType<SchemaValidationErrorResponse | void | ErrorOutput>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLinkPreview>>, TError,CreateLinkPreviewMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createLinkPreview>>,
        TError,
        CreateLinkPreviewMutationVariables,
        TContext
      > => {
      return useMutation(getCreateLinkPreviewMutationOptions(options), queryClient);
    }
